var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-pbx__change-cycle",domProps:{"innerHTML":_vm._s(_vm.$t('billing.pbx.contact_us_if_you_like_change',[_vm.cycle, _vm.payment, _vm.contactSalesLink]))},on:{"click":function($event){return _vm.handleClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }